import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLocalidad = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'localidad',
        name: 'Localidad',
        component: ViewLocalidad,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
